<template>
    <div class="etermin-filial-search max-width-2 p-0 position-relative" :class="`${proceed ? 'overlay-before': '' }`">
        <etermin v-if="proceed" :format="format" type="map" stylemodifier="etermin-with-map max-width pt-0 pt-lg-8 no-padding-mobile"></etermin>
        <notification-container class="max-width max-width-spacing" v-if="!proceed" />
        <component v-bind:is="appName" @acceptConsent="acceptMap" :cname="consentName" :consentInfo="consentInfo"></component>
    </div>
</template>

<script>
import StoresSearch from '@/components/StoresSearch'
import Etermin from '@/components/Etermin'
import NotificationContainer from '@/components/NotificationContainer.vue'
import ConsentPreview from '@/components/ConsentPreview.vue'

import { mapState } from 'vuex'

export default {
    name: 'search-app',
    components: {
        StoresSearch,
        NotificationContainer,
        ConsentPreview,
        Etermin
    },
    data () {
        return {
            format: 'modal',
            cmpReady: false,
            checkingInterval: null,
            consentName: 'Google Map',
            consentInfo: Drupal.t('The store locator service is provided by Google Maps. When you activate the service, cookies are set and personal data is processed.'),
            mapAccepted: false,
            appName: ''
        }
    },
    watch: {
        cmpReady: function (data) {
            if (data) {
                clearInterval(this.checkingInterval)
                var b = __cmp('getCMPData')
                if ('vendorConsents' in b) {
                    if ('s1104' in b.vendorConsents && b.vendorConsents['s1104']) {
                        this.appName = 'StoresSearch'
                        setTimeout(this.pageViewTraking, 1000, 'filialen')
                    } else {
                        this.appName = 'ConsentPreview'
                    }
                }
            }
        },
        proceed: function (data) {
            if (data) {
                setTimeout(this.pageViewTraking, 1000, 'service')
            }
        }
    },
    computed: {
        ...mapState([
            'loading',
            'initialPopup',
            'proceed'
        ])
    },
    methods: {
        acceptMap: function () {
            this.appName = 'StoresSearch'
            __cmp('setVendorConsent', ['s1104', 1 ])
            __cmp('setVendorConsent', ['s135', 1 ])
            localThis.pageViewTraking('filialen')
        },
        pageViewTraking: function (name) {
            let url = '/etermin/' + name
            // Google Tag-Manager push 'virtualPageView' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `virtual_page_view`,
                    event_type: ``,
                    event_data: {
                        path: url
                    }
                })
            }
        }
    },
    created () {
        let localThis = this
        this.checkingInterval = setInterval(function () {
            if (__cmp('consentStatus')) {
                if (__cmp('consentStatus').consentExists) {
                    localThis.cmpReady = true
                }
            }
        }, 500)
    }
}
</script>

<style lang="scss">

</style>
